import StaticContentMenu from './StaticContentMenu';

export default StaticContentMenu;
